import { Avatar } from '@appkit4/react-components/avatar';
import './YourEngagements.scss';
import { Badge } from '@appkit4/react-components/badge';

interface Owner {
    name: string;
    avatar: string;
}

interface TableRow {
    engagementName: string;
    documentType: string[];
    owner: Owner;
    lastUpdated: string;
    engagementType: string;
    validationStatus: string;
}

export const columns = [
    {
        field: 'engagementName',
        header: 'Engagement name',
        renderCell: (row: TableRow) => (
            <span className="fw-normal">{row.engagementName}</span>
        ),
    },
    {
        field: 'documentType',
        header: 'Document type',
        renderCell: (row: TableRow) => {
            const docs = row.documentType;
            return (
                <div className="d-flex align-items-center gap-2">
                    <span>{docs[0]}</span>
                    {docs.length > 1 && (
                        <span className="document-count">
                            +{docs.length - 1}
                        </span>
                    )}
                </div>
            );
        },
    },
    {
        field: 'owner',
        header: 'Owner',
        renderCell: (row: any) => (
            <div className="d-flex align-items-center gap-2">
                <Avatar label={row.owner.initials} />
                <span>{row.owner.name}</span>
            </div>
        ),
    },
    { field: 'lastUpdated', header: 'Last Updated' },
    {
        field: 'engagementType',
        header: 'Engagement type',
        renderCell: (row: any) => (
            <Badge
                value={row.engagementType}
                size={'lg'}
                type="warning"
                style={{ backgroundColor: '#FFECBD' }}
            ></Badge>
        ),
    },
    {
        field: 'validationStatus',
        header: 'Validation status',
        renderCell: (row: any) => {
            const typeClass = row.validationStatus
                .toLowerCase()
                .replace(' ', '-');
            return (
                <span className={`validation-status ${typeClass}`}>
                    {row.validationStatus}
                </span>
            );
        },
    },
];

export const tabs = [
    { label: 'All', value: 'all', icon: 'icon-document-multiple-outline' },
    {
        label: 'Classified extracted Documents',
        value: 'extracted',
        icon: 'icon-document-file-outline',
    },
    {
        label: 'Fill PDF documents',
        value: 'fillPdf',
        icon: 'icon-pdf-outline',
    },
    {
        label: 'Fill in online form documents',
        value: 'fillForm',
        icon: 'icon-document-file-outline',
    },
];
